import { cn, getRoleColor, formatTeamRole } from '@/lib/utils';

interface RoleBadgeProps {
  /** System role (SUPER_ADMIN, PROJECT_ADMIN, MODERATOR) or team role (owner, admin, editor, viewer) */
  role: string;
  className?: string;
}

/**
 * Colour-coded role badge. Handles both system roles and team roles.
 *
 * ```tsx
 * <RoleBadge role="editor" />       → "Editor"  (green)
 * <RoleBadge role="SUPER_ADMIN" />  → "Super Admin" (red)
 * ```
 */
export function RoleBadge({ role, className }: RoleBadgeProps) {
  const isTeamRole = ['owner', 'admin', 'editor', 'viewer'].includes(role);
  const label = isTeamRole ? formatTeamRole(role) : role.replace(/_/g, ' ');

  return (
    <span
      className={cn('rounded-full px-2 py-0.5 text-xs font-medium', getRoleColor(role), className)}
    >
      {label}
    </span>
  );
}
